import { redirect } from "@tanstack/react-router";

import { Level } from "@/gen/auth/common_pb";
import { Loading } from '@/layouts/loading';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(inventory)/branch/')({
  loader: async () => {
    const level = localStorage.getItem("level");
    if (level === Level.STOCK_POINT.toString()) {
        return redirect({
            to: "/overview",
        });
    }
    // Redirect to the reports section by default
    return redirect({
      to: "/branch/dashboard",
    });
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
})
